/**
 * DevExtreme (esm/__internal/core/r1/utils/render_utils.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const combineClasses = classesMap => Object.keys(classesMap).filter(cssClass => !!cssClass && classesMap[cssClass]).join(" ").split(" ").filter((cssClass, i, filteredClassesMap) => filteredClassesMap.indexOf(cssClass) === i).join(" ");